var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8314 9.83922C13.9206 13.1336 10.5118 15.0659 7.21742 14.1551C3.92307 13.2444 1.99078 9.83551 2.90151 6.54117C3.81224 3.24683 7.22113 1.31453 10.5155 2.22526C13.8098 3.13599 15.7421 6.54488 14.8314 9.83922ZM4.40587 6.95705C3.72482 9.42056 5.16979 11.9697 7.6333 12.6508C10.0968 13.3318 12.646 11.8868 13.327 9.42334C14.0081 6.95983 12.5631 4.41066 10.0996 3.72962C7.63608 3.04857 5.08691 4.49354 4.40587 6.95705Z",
    fill: "#D7D7D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1179 21.5918L11.9236 13.5834L13.2427 12.5213L20.1841 20.6381L19.1179 21.5918Z",
    fill: "#C0BDE8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.afb49361.svg";
export { ForwardRef as ReactComponent };